export const PRIMARY = "#E91E63";
export const LABEL = "#9C26B0";
export const SUCCESS = "#4CAF50";
export const ERROR = "#F44336";
export const INFO = "#00BCD4";
export const WHITE = "#FFFFFF";
export const WARNING = "#FF9800";
export const MUTED = "#979797";
export const CAPTION = "#4A4A4A";
